import Vue from 'vue'
import List from '@/components/list.vue'
import List2 from '@/components/list2.vue'
// import List3 from '@/components/list3.vue'
// import Tit from '@/components/part_title.vue'
import Article from '@/components/article.vue'
// import SmallSwiper from '@/components/small_swiper.vue'
import Seemore from '@/components/seemore.vue'
import mainSwiper from '@/components/main_swiper.vue'
// import Resource from '@/components/resource.vue'
// import Pages from '@/components/pages.vue'
// import BackTop from '@/components/backtop.vue'
// import PartTile from '@/components/title.vue'
// import ArticleList from '@/components/article_list.vue'
// import Toast from '@/components/toast.vue'
// import Local from '@/components/pageLocation.vue'


// 定义全局组件
  Vue.component('my-list', List)

  Vue.component('my-lists', List2)


// Vue.component('my-listss', List3)
// Vue.component('my-title', Tit)
  Vue.component('my-Article', Article)
// Vue.component('my-small-swiper', SmallSwiper)
  Vue.component('my-seemore', Seemore)

  Vue.component('my-main-swiper', mainSwiper)
// Vue.component('my-resource', Resource)
// Vue.component('my-page', Pages)
// Vue.component('my-back-top', BackTop)
// Vue.component('my-part-title', PartTile)
// Vue.component('my-article-list', ArticleList)
// Vue.component('my-toast', Toast)
// Vue.component('my-local', Local)
